import { PinnedPlaceholder, Reconnecting, RoomControls, Sidebar, VideoTile } from '@/components';
import { useClientHeight } from '@/hooks/useClientHeight';
import { useRoom } from '@/hooks/useRoom';
import { GridContainer, RoomContent, StyledRoom } from './styled';

function Room() {
  const height = useClientHeight();

  const { totalParticipants, isLocalAbsolute, participantSids, hasPinned } = useRoom();

  return (
    <StyledRoom>
      <RoomContent $height={height}>
        <PinnedPlaceholder />
        <GridContainer $hasPinned={hasPinned}>
          <VideoTile
            sid="local"
            isAbsolute={isLocalAbsolute}
            totalParticipants={totalParticipants}
            hasPinned={hasPinned}
          />
          {participantSids.map((sid) => (
            <VideoTile
              totalParticipants={totalParticipants}
              sid={sid}
              key={sid}
              hasPinned={hasPinned}
            />
          ))}
        </GridContainer>
        <Sidebar />
      </RoomContent>
      <RoomControls />
      <Reconnecting />
    </StyledRoom>
  );
}

export default Room;